// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"288":"edf72173","346":"336e34a4"}[chunkId] + ".css";
};